import React from "react";
import styled from "styled-components";
import Navbar from "../components/webpage/Navbar";
import Footer from "../components/webpage/Footer";
import PricingPlans from "../components/webpage/PricingPlans";

const Cennik = () => {
  return (
    <>
      <Navbar />
      <Wrapper>
    


        <PlansWrapper>
                  <HeaderSection>
          <Title>Przejrzysty cennik bez ukrytych kosztów</Title>
          <Subtitle>
            Wybierz plan dopasowany do potrzeb Twojej firmy. Każdy z nich zawiera dostęp do kluczowych funkcji analitycznych i pełne bezpieczeństwo danych.
          </Subtitle>
        </HeaderSection>
          <PricingPlans />
        </PlansWrapper>



      </Wrapper>
      <Footer />
    </>
  );
};

export default Cennik;



const Wrapper = styled.div`
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  width: 100%;
`;


const HeaderSection = styled.div`
  text-align: center;
  padding: 4rem 2rem 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;


const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #4b5563;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const PlansWrapper = styled.div`
  padding: 2rem 1rem 4rem;
`;

